const STORAGE_KEY = "recommender-states";

interface StorageData {
  [key: string]: boolean;
}

const getStorageData = (): StorageData => {
  if (typeof window === "undefined") return {};

  const storedValue = localStorage.getItem(STORAGE_KEY);
  return storedValue ? JSON.parse(storedValue) : {};
};

export const getModalHiddenState = (key: string): boolean => {
  const data = getStorageData();
  return data[key] ?? false;
};

export const setModalHiddenState = (key: string, isHidden: boolean): void => {
  if (typeof window === "undefined") return;

  const data = getStorageData();
  data[key] = isHidden;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};
